const TEMPLATE = `
<section id="team" class="our-team-about fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6">
                <p class="small-text-doctor-about" data-animate-child>
                    Про нас
                </p>
            </div>
            <div class="col-lg-6">
                <h3 class="team-member__name" data-animate-child data-delay="200">Точність у діагностиці</h3>
                <p class="team-member__description" data-animate-child data-delay="400">
                    Медична лабораторія Богомольця (БМЛ) прагне надавати точні та швидкі діагностичні послуги. Ми
                    поєднуємо передові технології та експертний аналіз, щоб забезпечити надійні результати та
                    підтримати медичних працівників.
                </p>
                <p class="team-member__description" data-animate-child data-delay="400">
                    БМЛ поєднує інновації та експертизу для надання точних діагностичних рішень. Наша відданість
                    якості та точності робить нас надійним партнером для медичних працівників та клінік.
                </p>

            </div>
        </div>
        <div class="doctors-carousel-wrapper" data-animate-child data-delay="800">

            <div id="about-us-doctors" data-section="about-us-doctors" data-animate-child data-delay="800">
                <!-- Сітка лікарів завантажиться сюди -->
            </div>
        </div>
    </div>
</section>
`;

class BmlAboutUsTeam extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-about-us-team', BmlAboutUsTeam);
